import { render, staticRenderFns } from "./Mails.vue?vue&type=template&id=d4e29e48&scoped=true"
import script from "./Mails.vue?vue&type=script&lang=ts"
export * from "./Mails.vue?vue&type=script&lang=ts"
import style0 from "./Mails.vue?vue&type=style&index=0&id=d4e29e48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e29e48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4e29e48')) {
      api.createRecord('d4e29e48', component.options)
    } else {
      api.reload('d4e29e48', component.options)
    }
    module.hot.accept("./Mails.vue?vue&type=template&id=d4e29e48&scoped=true", function () {
      api.rerender('d4e29e48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/Mails.vue"
export default component.exports